import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import Button from './shared/Button';
import { TbConfetti } from 'react-icons/tb';
import { isValidEmail } from '../utils/validate';

export default function WaitlistModal({
  close = () => void 0 as any
}) {

  const [ success, setSuccess ] = useState(false);
  const [ error, setError ] = useState("");
  const [ isLoading, setIsLoading ] = useState(false);
  const [ name, setName ] = useState("");
  const [ email, setEmail ] = useState("");
  const [ message, setMessage ] = useState("");


  const encode = (data: any) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]),
      )
      .join('&');
  }

  const onSubmit = (e:any) => {
    e.preventDefault();
    e.stopPropagation();

    setError("");
    if (!name.trim() || !email.trim()) {
      setError("Please, fill all the required fields.");
      return false;
    }
    if (!isValidEmail(email.trim())) {
      setError("Please, enter a valid email");
      return false;
    }

    setIsLoading(true);
    if (!localStorage.getItem(`waitlist_${email}`)) {

      localStorage.setItem(`waitlist_${email}`, "1");

      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({ 
          'form-name': "waitlist", 
          'name': name,
          'email': email,
          'message': message,
          'land_url': localStorage.getItem(`land_url`),
          'document.referrer': document.referrer
        }),
      });
  
      if (typeof window !== 'undefined') {
        (window as any)?.Intercom('boot', {
          app_id: 'pepn8atv',
          name: name,
          email: email,
          land_url: localStorage.getItem(`land_url`),
          document_referrer: document.referrer,
          is_waitlist: true
        });
      }
    }
    
    setTimeout(() => {
      setSuccess(true);
      setIsLoading(false);
    }, 1900)

    return false;
  }

  useEffect(() => {
    setError("");
  }, [name, email])

  useEffect(() => {
    window.addEventListener("keydown", (e) => {
      e.key == "Escape" && close();
    })
  }, []);
  
  return (
    <div className="fixed z-[1000000] left-0 top-0 w-[100svw] h-[100svh] flex items-center justify-center">
      <div className='bg-black/60 backdrop-blur-sm absolute w-full h-full left-0 top-0 z-[0]'></div>
      <div 
        className='absolute right-8 top-8'
        onClick={() => close()}
      >
        <StaticImage 
          alt="x"
          src="../images/x.png"
          className='invert-[0.7] transition-all cursor-pointer hover:opacity-70 z-[10] drop-shadow-lg'
          width={40}
          height={40}
        />
      </div>
      <div className='relative z-[1] animate-in zoom-in max-w-[95%] p-6 lg:p-8 bg-white rounded-xl w-[512px] max-h-[85svh] overflow-y-auto'>
        {!success 
          ? <div className='flex flex-col gap-2 w-full'>
            <h3 className='text-lg font-comico text-left'>WAITLIST</h3>
            <h2 className='text-3xl lg:text-4xl text-left'>Join the waitlist and get <span className='text-highlight'>500 free credits</span>!</h2>
            <form name="waitlist_2" method="post" onSubmit={onSubmit} className='mt-6 w-full flex flex-col gap-4'>
              <div className='flex flex-col items-start gap-1'>
                <label className='text-sm lg:text-base font-semibold'>Name</label>
                <input 
                  className='bg-grey rounded-lg p-4 w-full' 
                  placeholder='Enter your name'
                  type="text"
                  name="full_name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className='flex flex-col items-start gap-1'>
                <label className='text-sm lg:text-base font-semibold'>Email</label>
                <input 
                  className='bg-grey rounded-lg p-4 w-full' 
                  placeholder='Enter your business email'
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className='flex flex-col items-start gap-1'>
                <label className='text-sm lg:text-base font-semibold flex justify-between items-center w-full text-left'>
                  <span>What's your primary industry?</span> 
                  <small className='text-gray-400 mt-0.5'>OPTIONAL</small>
                </label>
                <input
                  className='bg-grey rounded-lg p-4 w-full' 
                  placeholder={`We would love to hear about you`}
                  type="text"
                  name="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
              <Button
                className='mt-6 w-full'
                variant='secondary'
                size="lg"
                type="submit"
                loading={isLoading}
                onClick={() => void 0}
              >
                {isLoading 
                  ? <>Joining...</>
                  : <>Join the waitlist!</>
                }
              </Button>
            </form>
            {error && <p className='text-sm lg:text-base mt-2 text-center text-red-600 font-semibold'>{error}</p>}
            <p className='text-sm lg:text-base mt-2 text-center'>Use your free credits to find new leads or automate your sales funnel. We won't spam. We'll just ping you when we are live.</p>
          </div>
          : <div className='flex flex-col items-center justify-center gap-6 text-center'>
            {/* <TbConfetti className='text-primary-300 text-7xl' /> */}
            <span className='text-6xl'>🎉</span>
            <p className='text-lg'>
              Thank you for joining the waitlist!
            </p>
            <p className='text-lg'>
              500 credits have been acredited to your account. We'll let you know when we are live!
            </p>
            <Button onClick={close}>Close</Button>
          </div>
        }
      </div>
    </div>
  )
}
